import { IWCCContentBlock, IWCCContentBlockSplitOptions } from "./blocks/block/block.interfaces";
import { WCCContentBlockFactory } from "./parser.interfaces";

export class WCCContentContentSeparator {
    constructor() { }

    separate(content: string, options: IWCCContentBlockSplitOptions, factory: WCCContentBlockFactory<[string, boolean]>) {
        const prefix = options.prefix?.source ?? '';
        const postfix = options.postfix?.source ?? '';
        const pattern = options.pattern;

        const combinedRegexSource = `${prefix.length > 0 ? `(${prefix})` : ''}${pattern.source}${postfix.length > 0 ? `(${postfix})` : ''}`;
        const combinedRegex = new RegExp(combinedRegexSource, pattern.flags);

        const combinedRegexMatch = combinedRegex.exec(content);

        if (combinedRegexMatch != undefined) {
            const match = pattern.exec(combinedRegexMatch[0]);

            if (match != undefined) {
                const item = match[0];

                const lIdx = match.index + combinedRegexMatch.index;
                const rIdx = lIdx + item.length;

                let result = <Array<IWCCContentBlock>>[];

                if (lIdx > 0)
                    result = result.concat(this.separate(content.substring(0, lIdx), options, factory));

                result.push(factory(item, true));

                if (rIdx < content.length)
                    result = result.concat(this.separate(content.substring(rIdx), options, factory));

                return result;
            }
        } 

        return [factory(content, false)];
    }
}

const instance = new WCCContentContentSeparator();

export default instance;